export default "__VITE_ASSET__Z_a317fH__"